module.exports = __webpack_public_path__ + "img/travel_tiger_market_1.ab32c0f8.webp";